<div class="col-12 p-3 p-lg-0 container-form-modal-pages" mat-dialog-content>
    <div class="mt-4">
        <p class="description">{{ data.message }}</p>
    </div>
    <div class="d-flex justify-content-end mt-3 mt-lg-4" mat-dialog-actions>
        <button class="btn btn-continue" mat-button (click)="close()" cdkFocusInitial>Aceptar</button>
    </div>
</div>
